import LoggingPage from './loggingPage';
export default LoggingPage;
